import { useEffect, useState } from "react";
import markerSDK from "@marker.io/browser";

import { MARKER_PROJECT_ID } from "constants/index";

let markerWidgetInstance = null;
let markerWidgetPromise = null;

const loadMarkerWidget = () => {
  if (markerWidgetInstance) {
    return Promise.resolve(markerWidgetInstance);
  }

  if (!markerWidgetPromise) {
    markerWidgetPromise = markerSDK
      .loadWidget({ project: MARKER_PROJECT_ID })
      .then((widget) => {
        markerWidgetInstance = widget;
        return widget;
      })
      .catch((error) => {
        markerWidgetPromise = null;
        // eslint-disable-next-line no-console
        console.error("Failed to load Marker.io widget:", error);
        throw error;
      });
  }

  return markerWidgetPromise;
};

const useMarkerWidget = (enabled = true) => {
  const [widget, setWidget] = useState(markerWidgetInstance);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let isMounted = true;

    loadMarkerWidget()
      .then((loadedWidget) => {
        if (isMounted) {
          setWidget(loadedWidget);
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, [enabled]);

  const openMarkerWidget = () => {
    if (!enabled) {
      return;
    }
    if (widget) {
      widget.capture();
      return;
    }
    loadMarkerWidget()
      .then((loadedWidget) => {
        loadedWidget.capture();
      })
      .catch(() => {});
  };

  return { widget, openMarkerWidget };
};

export default useMarkerWidget;
